import React, {useEffect, useState} from "react";
import OdontogramSet from "../gigi/modules/odontogram-module/OdontogramSet";
import Card from "../component/Card";
import Table from "../component/Table";
import ApiConsumer from "../gigi/ApiConsumer";
import { OdontogramContext } from '../../context';

const HistoryGigi = ({visit}) => {

    const [odontogramDatas, setOdontogramDatas] = useState([])
    const [odontogramHistories, setOdontogramHistories] = useState([])

    useEffect(() => {
        ApiConsumer.getTeethAnamneseByPatient(visit.patient_id).then(res => {
            setOdontogramDatas(res)
        })
    }, [])

    return <>
        <OdontogramContext.Provider
            value={{
                handleHistoryClick: e => setOdontogramHistories(odontogramDatas[e]),
                handleSubmit: () => {},
                patient: visit,
                toothStatusDatas: visit.toothStatusDatas,
                parentCallback: () => {}
            }}>
            <div className='card'>
                <OdontogramSet
                    odontogramData={odontogramDatas}
                    openModal={() => {}}
                    handleHistoryClick={e => setOdontogramHistories(odontogramDatas[e])}
                    nextTab={() => {}}
                    readOnly={true}
                />
                {!!(odontogramHistories && odontogramHistories.length) && <>
                    <Card.ModuleHeader header='Riwayat Gigi'/>
                    <Table
                        headers={[
                            'No',
                            'Tanggal',
                            'Diagnosa',
                            'Status Gigi',
                            'Tindakan',
                            'Catatan',
                            ''
                        ]}
                        data={odontogramHistories}
                        columnMapper={data => [
                            data.created_at,
                            Array.isArray(data.diagnose_name) ?
                                (data.diagnose_name.length === 1 ?
                                        data.diagnose_name :
                                        <ul>{data.diagnose_name.map(v => <li>{v}</li>)}</ul>
                                ) :
                                data.diagnose_name,
                            data.name,
                            Array.isArray(data.treatment_name) ?
                                (data.treatment_name.length === 1 ?
                                        data.treatment_name :
                                        <ul>{data.treatment_name.map(v => <li>{v}</li>)}</ul>
                                ) :
                                data.treatment_name,
                            data.catatan ?? '',
                        ]}
                        listsPerPage={5}
                    ></Table>
                </>}
            </div>
        </OdontogramContext.Provider>
    </>
}

export default HistoryGigi